module.exports = __webpack_public_path__ + "static/tetris-972ae727bf4a36570f16f5269b93ad68.gif";